<template>
  <v-layout>
    <slot />
  </v-layout>
</template>
